<template>

    <base-popup v-if="stationSgid" @close="close()">
        <v-layout wrap row class="station-detail">
            <ApolloQuery
                    class="fill-height full-width"
                    fetchPolicy="network-only"
                    client-id="clientPrivate"
                    :query="require('../graphql/queries/station.gql')"
                    :variables="{ id: stationSgid }">
                <template v-slot="{ result: { error, data }, isLoading }">


                    <v-layout v-if="isLoading" class="loading" row wrap align-center justify-center fill-height>
                        <v-flex shrink>
                            <v-progress-circular
                                    :size="70"
                                    :width="1"
                                    height="15"
                                    indeterminate
                                    color="primary"
                            ></v-progress-circular>
                        </v-flex>
                    </v-layout>

                    <station-info v-else-if="data && data.station" :station="data.station" ></station-info>


                    <v-layout v-else class="noresult" row wrap align-center justify-center fill-height>
                        <v-flex shrink>
                            {{$vuetify.t("$vuetify.PopUpStation.noResult")}}
                        </v-flex>
                    </v-layout>
                </template>
            </ApolloQuery>
        </v-layout>
        <v-layout wrap row>
            <v-flex xs12 align-self-end class="button-for-station">
                <v-layout justify-center fill-height row wrap>
                    <v-flex text-xs-center xs12 align-self-start>
                        <v-btn color="button-dark" class="button-go-station" :to="{name: 'station-pickup', params: {sgid: stationSgid }}">
                            {{$vuetify.t("$vuetify.PopUpStation.goToStation") | uppercase}}
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

    </base-popup>


</template>

<script>

    import StationInfo from "./StationInfo"
    import BasePopup from "./BasePopUp"


    export default {
        data() {
            return {
                station: {
                    name: "ciao"
                },
                attrToShow: ["name",]
            }
        },
        props: {
            stationSgid: String

        },
        methods: {
            close(){
                this.$emit("close")
            }
        },
        components: {
            StationInfo,
            BasePopup
        }
    }


</script>

<style lang="scss" scoped>


    .station-detail{
        height: calc(100% - 60px);

        .full-width{
            width: 100%;
        }
    }

    .button-for-station{
        height: 60px;

        .button-go-station{
            margin: auto;
            min-width: 190px;

            & /deep/ .v-btn__content{
                color: var(--v-primary-base);
                font-size: 20px

            }
        }

    }


</style>